import FJUtil from './FJUtil';
import Download from '../lib/download';
import { Buffer } from 'buffer';
import '../lib/zip/zip';
import '../lib/zip/zip-fs';
import '../lib/zip/deflate';
import '../lib/zip/inflate';
import { sha256 } from 'js-sha256';
//'crypto-js' 需要预加载文件，否则会报错
import 'crypto-js/x64-core.js';
import 'crypto-js/sha512';
import 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import { UPLOAD_FILE_TYPE, UPLOAD_FILE_TYPE_NO_GIF } from '../config/dataConfig/FJGenerateData';
import FJLoadLocalforageStore from '../store/FJLoadLocalforageStore';
import localforage from 'localforage';
import FJConfig from '../config/FJConfig.js';
import FJNetworkStore from '../store/FJNetworkStore.js';
import FJImageStore from '../store/FJImageStore.js';

window.zip && (window.zip.useWebWorkers = false);

let _AudioContext = null;

function writeString(view, offset, string) {
    for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
    }
}

function floatTo16BitPCM(output, offset, input) {
    for (var i = 0; i < input.length; i++, offset += 2) {
        var s = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
}

const FJFileHandleUtil = {
    loadFileToUrl: file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = function (e) {
                resolve(e.target.result);
            };
            reader.onerror = function () {
                reject();
            };
            reader.readAsDataURL(file);
        });
    },
    loadImageFile(file, success, error) {
        const reader = new FileReader();
        reader.onload = function (e) {
            const img = new Image();
            img.onload = function () {
                success(img);
            };
            img.onerror = function (e) {
                console.log(e);
                error();
            };
            img.src = e.target.result;
        };
        reader.onerror = function () {
            error();
        };
        reader.readAsDataURL(file);
    },
    loadImageFileAsync(file) {
        return new Promise(resolve => {
            try {
                const reader = new FileReader();
                reader.onload = function (e) {
                    const img = new Image();
                    img.onload = function () {
                        resolve(img);
                    };
                    img.onerror = function (e) {
                        console.log(e);
                        resolve();
                    };
                    img.src = e.target.result;
                };
                reader.onerror = function () {
                    resolve();
                };
                reader.readAsDataURL(file);
            } catch (error) {
                resolve();
            }
        });
    },
    loadImageAsync(url) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = url;
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error(`Failed to load image: ${url}`));
        });
    },
    downloadImage(url) {
        return new Promise((res, rej) => {
            const image = new Image();
            image.setAttribute('crossOrigin', 'anonymous');
            //有缓存时处理
            image.src = url;
            image.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = image.width;
                canvas.height = image.height;
                ctx.drawImage(image, 0, 0);
                canvas.toBlob(blob => {
                    res(blob);
                });
            };
            image.onerror = rej;
        });
    },

    async downloadVideo(url) {
        try {
            const res = await fetch(url);
            const blob = await res.blob();
            return blob;
        } catch (e) {
            return null;
        }
    },

    async downloadVideoCacheAvoidance(url) {
        let blob = null;
        try {
            blob = await FJUtil.downloadVideo(url);
            if (!blob) throw new Error();
        } catch (error) {
            const newUrl = url + `?v=${new Date().getTime()}`;
            blob = await FJUtil.downloadVideo(newUrl);
        }
        return blob;
    },

    async downloadImageCacheAvoidance(url) {
        let blob = null;
        try {
            blob = await FJUtil.downloadImage(url);
            if (!blob) throw new Error();
        } catch (error) {
            const newUrl = url + `?v=${new Date().getTime()}`;
            blob = await FJUtil.downloadImage(newUrl);
        }
        return blob;
    },
    blobToBuffer: function (blob) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                let buf = new Uint8Array(reader.result);
                let binaryBuffer = Buffer.alloc(buf.byteLength);
                for (let i = 0; i < buf.length; ++i) {
                    binaryBuffer[i] = buf[i];
                }
                resolve(binaryBuffer);
            };
            reader.onerror = reject;
            reader.onabort = reject;
            reader.readAsArrayBuffer(blob);
        });
    },
    getBlobByUrl: function (url) {
        return new Promise(res => {
            try {
                let xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.onload = function () {
                    if (this.status == 200) {
                        res(this.response);
                    }
                };
                xhr.onerror = () => {
                    res('');
                };
                xhr.send();
            } catch (e) {
                res('');
            }
        });
    },
    saveBlobsInZip(blobs, fileName, onComplete, onFail) {
        let zipFs = new window.zip.fs.FS();
        let dir = zipFs.root.addDirectory(fileName);
        blobs.forEach(blob => {
            try {
                dir.addBlob(blob.name, blob);
            } catch (error) {
                //处理重名文件
                dir.addBlob(blob.name + new Date().getTime(), blob);
            }
        });
        zipFs.exportBlob(
            function (zippedBlob) {
                Download(zippedBlob, fileName + '.zip', 'application/zip');
                if (onComplete) {
                    setTimeout(onComplete, 300);
                }
            },
            null,
            () => {
                if (onFail) onFail();
            },
        );
    },
    convertToArrayBuffer: function (source) {
        return new Promise((resolve, reject) => {
            // source is blob or blob url
            if (source === null) {
                reject(null);
            }
            if (typeof source === 'string') {
                // blob url
                var xhr = new XMLHttpRequest();
                xhr.open('GET', source, true);
                xhr.responseType = 'arraybuffer';
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    } else {
                        resolve(null);
                    }
                };
                xhr.onerror = () => {
                    resolve(null);
                };
                xhr.ontimeout = () => {
                    resolve(null);
                };

                xhr.send();
            } else {
                try {
                    const fileReader = new FileReader();
                    fileReader.onload = () => {
                        resolve(fileReader.result);
                    };
                    fileReader.onerror = () => {
                        resolve(null);
                    };
                    fileReader.readAsArrayBuffer(source);
                } catch (e) {
                    console.log(e, source);
                    resolve(null);
                }
            }
        });
    },
    getHashBuffer: function (source, threshold = 1073741824) {
        let size = source.size ? source.size : source.length;

        // 默认超过1G会进行裁剪
        if (size > threshold) {
            let offset = 0; // Math.floor((size - threshold)/2);
            source = source.slice(offset, offset + threshold);
        }

        if (source.arrayBuffer) {
            return source.arrayBuffer();
        } else {
            return this.convertToArrayBuffer(source);
        }
    },

    /**
     * @description 处理文件、跳转逻辑
     * @param files
     * @param params
     * @param jumpUrl
     * @param filesKey
     * @returns {Promise<void>}
     */
    readFiles: async function (files, params = {}, jumpUrl = () => {}, filesKey = 'fileList') {
        if (files.length < 1) {
            return;
        }

        let input_files = []; // localstorage中存储的文件信息
        let tasks = []; // localforage中存储的文件

        for (let i = 0; i < files.length; i++) {
            let file = files[i];

            // 判断文件大小不能超过3G
            if (file.size > 1073741824 * 3) {
                console.log('size > 1073741824 * 3');
                continue;
            }

            let blob = file instanceof Blob ? file : new Blob([file]);
            const arrayBuffer = await FJUtil.getHashBuffer(blob);
            let buffer = new Uint8Array(arrayBuffer);
            let hash = sha256.create();
            hash.update(buffer);
            let key = hash.hex();

            input_files[i] = {
                key,
                info: {
                    type: file.type,
                    size: file.size,
                    name: file.name,
                },
            };

            let task = [];

            let mainFile = new File([file], file.name, { type: file.type });

            task = FJLoadLocalforageStore.setItem(key, {
                data: mainFile,
                type: file.type,
                size: file.size,
                name: file.name,
            });

            tasks.push(task);
        }

        let goToEditor = () => {
            const uploadKey = sha256('chooseFilesInfo');
            // ADD_RECORD_VIDEO replace uploadKey
            localStorage.setItem(uploadKey, JSON.stringify(Object.assign({}, params, { [filesKey]: input_files })));
            jumpUrl(uploadKey);
        };

        if (tasks.length > 0) {
            Promise.all(tasks).then(() => {
                goToEditor();
            });
        }
    },

    arrayBufferToBuffer: function (arrayBuffer) {
        let buffer = Buffer.alloc(arrayBuffer.byteLength);
        let view = new Uint8Array(arrayBuffer);
        for (let i = 0; i < buffer.length; ++i) {
            buffer[i] = view[i];
        }
        return buffer;
    },
    hashEncode: async function (target) {
        let threshold = 1048576; // 1M
        let source = target;
        const size = source.size || source.length;

        if (size > threshold) {
            // 新版本的生成基于 gapLength 进行分割
            const gapLength = 10;
            const type = source.type;
            const originSliceLength = Math.floor(size / gapLength);
            const finalSliceLength = Math.floor(threshold / gapLength);
            const sliceBlobs = [];
            for (let i = 0; i < gapLength; i++) {
                const start = originSliceLength * i;
                const end = start + finalSliceLength;
                sliceBlobs.push(source.slice(start, end));
            }
            source = new Blob(sliceBlobs, { type });
        }

        let arrayBuffer;
        if (source.arrayBuffer) {
            arrayBuffer = await source.arrayBuffer();
        } else {
            arrayBuffer = await this.convertToArrayBuffer(source);
        }
        const binaryString = new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), '');
        const hash = CryptoJS.SHA256(binaryString).toString();
        return hash;
    },

    isGIF: function (image) {
        // 通过File对象的type属性判断
        if (image instanceof File) {
            return image.type === 'image/gif';
        }
        // 通过图片的URL判断（仅适用于本地图片）
        else if (typeof image === 'string') {
            let img = new Image();
            img.src = image;
            return new Promise(resolve => {
                img.onload = () => {
                    let canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    let ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    let dataURL = canvas.toDataURL('image/gif');
                    resolve(dataURL.startsWith('data:image/gif'));
                };
            });
        }
        return false;
    },

    /**
     * 判断文件格式是否支持
     * @param {File} file - 要判断的文件
     * @param {Array} supportedFormats - 支持的文件格式列表
     * @returns {boolean} - 如果文件格式支持，返回true；否则返回false
     */
    isFileFormatSupported: function (file, supportedFormats) {
        if (!(file instanceof File)) {
            throw new Error('参数file必须是File对象');
        }
        if (!Array.isArray(supportedFormats)) {
            throw new Error('参数supportedFormats必须是数组');
        }
        const fileType = file.type;
        return supportedFormats.includes(fileType);
    },
    isImage: function (file, includeGif = false, imageTypes) {
        const useImageTypes = imageTypes || includeGif ? UPLOAD_FILE_TYPE : UPLOAD_FILE_TYPE_NO_GIF;
        if ((file instanceof File || file instanceof Blob) && file.type) {
            return useImageTypes.includes(file.type);
        }
        return false;
    },
    isAudio: function (file, types) {
        const useTypes = types;
        if ((file instanceof File || file instanceof Blob) && file.type) {
            return useTypes.includes(file.type);
        }
        return false;
    },
    checkImageSize: function (file, options = {}) {
        return new Promise((resolve, reject) => {
            const { pixel = 300 } = options;
            if (file instanceof File || file instanceof Blob) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    const img = new Image();
                    img.onload = function () {
                        const width = img.width;
                        const height = img.height;
                        resolve(width < pixel || height < pixel);
                    };
                    img.onerror = e => {
                        reject(e);
                    };
                    img.src = e.target.result;
                };
                reader.onerror = e => {
                    reject(e);
                };
                reader.readAsDataURL(file);
            } else {
                const img = new Image();
                img.onload = function () {
                    const width = img.width;
                    const height = img.height;
                    resolve(width < pixel || height < pixel);
                };
                img.onerror = e => {
                    reject(e);
                };
                img.src = file;
            }
        });
    },
    getReloadNewUrl: function (url) {
        if (!url) return url; // 处理空字符串或未定义的情况

        // 检查是否已经包含 v 参数
        const hasVParam = url.includes('v=');
        const separator = url.includes('?') ? '&' : '?'; // 判断是否需要添加 ? 或 &

        if (hasVParam) {
            // 如果已经包含 v 参数，则覆盖其值
            return url.replace(/([?&]v=)[^&]*/, `$1${new Date().getTime()}`);
        } else {
            // 如果未包含 v 参数，则追加
            return `${url}${separator}v=${new Date().getTime()}`;
        }
    },
    getLocalStorageImage: async function (url, callback) {
        const cacheKey = 'cached-image-' + url;
        const cachedImage = await localforage.getItem(cacheKey);
        if (cachedImage) {
            // 如果缓存存在，则使用缓存的图片
            callback('data:image/png;base64,' + cachedImage);
        } else {
            let isRrLoading = false;
            const image = new Image();
            image.crossOrigin = 'Anonymous';
            image.onload = function () {
                const canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(this, 0, 0);
                const dataURL = canvas.toDataURL('image/png');
                localforage.setItem(cacheKey, dataURL.substring(dataURL.indexOf(',') + 1));
                callback(dataURL);
            };

            image.onerror = function () {
                if (!isRrLoading) {
                    isRrLoading = true;
                    image.src = url + '?v=' + new Date().getTime();
                } else {
                    callback('');
                }
            };
            image.src = url;
        }
    },

    /**
     * @desc 解决跨域问题
     * @param {string} url
     * @returns {Promise<Blob>}
     */
    getBlobByUrlSolveCrossOrigin: async function (url) {
        let blob = await FJUtil.getBlobByUrl(url);

        if (!blob) {
            blob = await FJUtil.getBlobByUrl(url + '?v=' + Date.now());
        }

        if (!blob) {
            return null;
        }

        return URL.createObjectURL(blob);
    },

    getAudioSampleRate: function () {
        let sr = this.getAudioContext().sampleRate;
        return sr <= 44100 ? sr : 48000;
    },
    getAudioContext: function (shouldCreateNew) {
        if (shouldCreateNew) {
            return new (window.AudioContext || window.webkitAudioContext)();
        }

        if (_AudioContext) {
            return _AudioContext;
        } else {
            _AudioContext = new (window.AudioContext || window.webkitAudioContext)();
            return _AudioContext;
        }
    },

    /**
     * @description 转MP3
     * @param buffer
     * @param channels
     * @returns {Promise<unknown>}
     */
    encodeMp3: function (buffer, channels = 1) {
        return new Promise(res => {
            const taskType = 'encodeAudioDataToMp3';
            const produceAudioWorker = new Worker(FJConfig.produceAudioWorkerPath);
            produceAudioWorker.postMessage({
                sampleRate: this.getAudioSampleRate(),
                audioBuffer: buffer,
                channels: channels,
                taskType,
            });
            produceAudioWorker.onmessage = message => {
                const { data } = message;
                const { result, type } = data;
                if (taskType === type) {
                    res(result);
                } else if (type === 'error') {
                    res();
                }
            };
        });
    },

    encodeWAV: function (samples, channels = 2) {
        let sampleRate = FJUtil.getAudioSampleRate();
        let numChannels = channels;
        let bitDepth = 16;
        var bytesPerSample = bitDepth / 8;
        var blockAlign = numChannels * bytesPerSample;
        var buffer = new ArrayBuffer(44 + samples.length * bytesPerSample);
        var view = new DataView(buffer);

        /* RIFF identifier */
        writeString(view, 0, 'RIFF');
        /* RIFF chunk length */
        view.setUint32(4, 36 + samples.length * bytesPerSample, true);
        /* RIFF type */
        writeString(view, 8, 'WAVE');
        /* format chunk identifier */
        writeString(view, 12, 'fmt ');
        /* format chunk length */
        view.setUint32(16, 16, true);
        /* sample format (raw) */
        view.setUint16(20, 1, true);
        /* channel count */
        view.setUint16(22, numChannels, true);
        /* sample rate */
        view.setUint32(24, sampleRate, true);
        /* byte rate (sample rate * block align) */
        view.setUint32(28, sampleRate * blockAlign, true);
        /* block align (channel count * bytes per sample) */
        view.setUint16(32, blockAlign, true);
        /* bits per sample */
        view.setUint16(34, bitDepth, true);
        /* data chunk identifier */
        writeString(view, 36, 'data');
        /* data chunk length */
        view.setUint32(40, samples.length * bytesPerSample, true);

        floatTo16BitPCM(view, 44, samples);

        return buffer;
    },

    getAudioDurationWithUrl: function (url) {
        return new Promise((resolve, reject) => {
            let audio = document.createElement('audio');

            function addEvent() {
                FJUtil.addEvent(audio, 'loadeddata', onLoaded);
                FJUtil.addEvent(audio, 'error', onError);
            }

            function removeEvent() {
                FJUtil.removeEvent(audio, 'loadeddata', onLoaded);
                FJUtil.removeEvent(audio, 'error', onError);
                audio.src = '';
                audio = null;
            }

            function onLoaded() {
                let duration = audio.duration;
                removeEvent();
                resolve(duration);
            }

            function onError(e) {
                removeEvent();
                console.log(e);
                reject(new Error('getAudioDurationWithUrl error'));
            }

            addEvent();
            audio.src = url;
        });
    },

    uploadWaveform: async function (file, eventId) {
        const id = await FJUtil.hashEncode(file);
        const key = FJConfig.waveformKey + `${id}.png`;
        const result = await FJImageStore.upLoadFileToS3Async(file, key);
        if (result) {
            FJNetworkStore.updateEventInfo({
                eventId: eventId,
                info: {
                    waveformId: `${id}.png`,
                },
            });
        }
    },
    /**
     * @desc 检查图片是否可用于本地文件
     * @param {*} url
     * @returns
     */
    checkImageCanDownload: function (url) {
        return new Promise(async res => {
            try {
                const blob = await FJUtil.getBlobByUrl(url);
                if (blob) {
                    let img = document.createElement('img');
                    img.onload = () => {
                        res(true);
                        document.body.removeChild(img);
                    };
                    img.error = () => {
                        res(false);
                        document.body.removeChild(img);
                    };
                    document.body.appendChild(img);
                    img.src = url;
                } else {
                    res(false);
                }
            } catch (error) {
                res(false);
            }
        });
    },
    filterCanDownloadImages: async function (images) {
        const results = await Promise.all(
            images.map(async item => {
                const canDownload = await FJUtil.checkImageCanDownload(item.url);
                return { item, canDownload };
            }),
        );
        return results.filter(result => result.canDownload).map(result => result.item);
    },
    isPptFile: function (filename) {
        return /\.(pptx|ppt|pdf)$/i.test(filename);
    },
    getEspText: function (name, fontSize, maxWidth) {
        if (!name || typeof name !== 'string') {
            return '';
        }
        let fileText;
        let fileExt = FJUtil.getPathSuffix(name);

        if (fileExt.length === 0 || fileExt.length >= 5) {
            return {
                fileTextType: 'NO EXT',
                fileName: name,
                fileText: name,
            };
        }

        const fontInfo = {
            fontFamily: 'Roboto',
            fontSize,
        };
        const fileName = name.replace('.' + fileExt, '');
        const extWidth = fileExt ? FJUtil.calcTextSize(fileExt, fontInfo).width : 0; // 后缀的宽度
        const nameWidth = FJUtil.calcTextSize(name, fontInfo).width; // 完整那么的宽度
        const lastChar = fileExt === '' ? fileName.slice(fileName.length - 4) : fileName[fileName.length - 1];
        const lastCharWidth = FJUtil.calcTextSize(lastChar, fontInfo).width;

        // 所能容纳下的最大宽度
        const filePureNameMaxWidth = maxWidth - extWidth - lastCharWidth;

        if (maxWidth > 0 && nameWidth > 0 && nameWidth >= maxWidth) {
            const ratio = filePureNameMaxWidth / nameWidth;
            let index = Math.floor(fileName.length * ratio);
            let text = fileName.slice(0, index);
            let textWidth = FJUtil.calcTextSize(text, fontInfo).width;

            if (textWidth > filePureNameMaxWidth) {
                index--;
                while (textWidth < filePureNameMaxWidth && index > 10) {
                    text = fileName.slice(0, index);
                    textWidth = FJUtil.calcTextSize(text, fontInfo).width;
                    index--;
                }
            } else if (textWidth < filePureNameMaxWidth) {
                index++;
                let oldText = text;
                while (textWidth > filePureNameMaxWidth) {
                    oldText = text;
                    text = fileName.slice(0, index);
                    textWidth = FJUtil.calcTextSize(text, fontInfo).width;
                    if (textWidth === 0) {
                        textWidth = 99999;
                    }
                    index++;
                }
                text = oldText;
            }
            fileText = text + '...' + lastChar + '.' + fileExt;
        } else {
            fileText = name;
        }

        return {
            fileTextType: 'HAS EXT',
            fileName: fileName,
            fileText: fileText,
        };
    },
};
export default FJFileHandleUtil;
